var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1500.000000pt",
    height: "1500.000000pt",
    viewBox: "0 0 1500.000000 1500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,1500.000000) scale(0.100000,-0.100000)",
    fill: "#ff3030",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7240 12494 c-1100 -64 -2104 -460 -2955 -1165 -136 -112 -500 -478 -617 -619 -431 -520 -751 -1105 -939 -1715 -391 -1270 -273 -2625 330 -3790 266 -513 598 -950 1036 -1362 699 -657 1586 -1100 2542 -1267 79 -14 247 -37 375 -51 l233 -26 2335 3 2335 3 80 28 c207 74 361 226 430 427 26 76 29 98 29 210 0 112 -3 134 -29 210 -69 201 -223 353 -430 427 l-80 28 -504 3 -504 3 145 147 c167 169 224 232 353 392 1036 1291 1360 3014 866 4615 -188 610 -508 1195 -939 1715 -117 141 -481 507 -617 619 -793 657 -1706 1041 -2725 1146 -147 15 -611 27 -750 19z m690 -1358 c855 -107 1609 -482 2201 -1094 569 -587 911 -1317 1011 -2157 17 -145 17 -625 0 -770 -100 -840 -442 -1570 -1011 -2157 -602 -622 -1371 -999 -2246 -1100 -144 -17 -626 -17 -770 0 -1038 120 -1933 632 -2552 1460 -390 520 -625 1119 -705 1797 -17 145 -17 625 0 770 124 1045 631 1932 1460 2552 519 389 1171 644 1797 703 61 5 126 12 145 14 76 9 562 -4 670 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7342 9760 c-739 -104 -1194 -841 -956 -1548 66 -199 197 -384 374 -531 l65 -54 5 -926 5 -926 29 -84 c71 -203 226 -357 427 -426 76 -26 97 -29 214 -29 117 0 138 3 214 29 201 69 356 223 427 426 l29 84 3 931 3 932 72 62 c206 179 337 399 393 660 27 123 25 362 -3 486 -106 457 -455 801 -915 900 -88 18 -299 26 -386 14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f333839a2d54a72f4a6adac2d0e6a60a.svg";
export { ForwardRef as ReactComponent };